module.exports = __webpack_public_path__ + "static/media/freya_yeh.735ef5d1.jpg";